export default "__VITE_ASSET__D0DVI5sZ__"